import { itemApi } from "@api/items";
import { loanApi } from "@api/loans";
import { invenioConfig } from "@config";
import { sendErrorNotification } from "@components/Notifications";

export const IS_LOADING = "fetchDocumentItems/IS_LOADING";
export const SUCCESS = "fetchDocumentItems/SUCCESS";
export const HAS_ERROR = "fetchDocumentItems/HAS_ERROR";

export const fetchDocumentItems = (documentPid) => {
  return async (dispatch) => {
    dispatch({
      type: IS_LOADING,
    });

    try {
      const itemsResponse = await itemApi.list(
        itemApi.query().withDocPid(documentPid).qs()
      );

      const activeStates = invenioConfig.CIRCULATION.loanActiveStates || [
        "ITEM_ON_LOAN",
      ];
      const loansQuery = loanApi
        .query()
        .withDocPid(documentPid)
        .withState(activeStates)
        .qs();

      const loansResponse = await loanApi.list(loansQuery);

      const loansByItemPid = {};
      (loansResponse.data.hits || []).forEach((hit) => {
        const loan = hit._source || hit;
        const itemPid =
          loan.metadata?.item_pid?.value || loan.metadata?.item_pid;
        if (itemPid) {
          loansByItemPid[itemPid] = loan;
        }
      });

      const enrichedHits = itemsResponse.data.hits.map((item) => {
        const itemPid = item.metadata?.pid;
        const activeLoan = loansByItemPid[itemPid];

        if (activeLoan) {
          return {
            ...item,
            metadata: {
              ...item.metadata,
              circulation: {
                state: activeLoan.metadata.state,
                loan_pid: activeLoan.metadata.pid,
              },
            },
          };
        }
        return item;
      });

      dispatch({
        type: SUCCESS,
        payload: {
          ...itemsResponse.data,
          hits: enrichedHits,
        },
      });
    } catch (error) {
      dispatch({
        type: HAS_ERROR,
        payload: error,
      });
      dispatch(sendErrorNotification(error));
    }
  };
};
